import React, { useEffect, useMemo, useRef, useState } from "react";
import { Check, ChevronDown, Search, Users, X } from "lucide-react";

const userName = (user) => user?.fullName || `${user?.firstName || ""} ${user?.lastName || ""}`.trim() || user?.username || `#${user?.id}`;

export default function EmployeeMultiSelect({ users = [], value = [], onChange, disabled = false }) {
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState("");
    const rootRef = useRef(null);
    const selectedIds = useMemo(() => new Set(value.map(String)), [value]);

    useEffect(() => {
        const closeOnOutsideClick = (event) => {
            if (!rootRef.current?.contains(event.target)) setOpen(false);
        };
        document.addEventListener("mousedown", closeOnOutsideClick);
        return () => document.removeEventListener("mousedown", closeOnOutsideClick);
    }, []);

    const filteredUsers = users.filter((user) => userName(user).toLowerCase().includes(query.trim().toLowerCase()));
    const selectionLabel = selectedIds.size === 0
        ? `Tous les collaborateurs (${users.length})`
        : selectedIds.size === 1
            ? userName(users.find((user) => selectedIds.has(String(user.id))))
            : `${selectedIds.size} collaborateurs sélectionnés`;

    const toggleUser = (id) => {
        const key = String(id);
        onChange(selectedIds.has(key)
            ? value.filter((selectedId) => String(selectedId) !== key)
            : [...value, key]);
    };

    return (
        <div className="pcyc-employee-picker" ref={rootRef}>
            <span className="pcyc-employee-picker-label">Collaborateurs ciblés</span>
            <button type="button" className={`pcyc-employee-picker-trigger ${open ? "is-open" : ""}`} onClick={() => setOpen((current) => !current)} disabled={disabled} aria-expanded={open}>
                <Users size={16} />
                <span>{selectionLabel}</span>
                {selectedIds.size > 1 && <b>{selectedIds.size}</b>}
                <ChevronDown size={16} />
            </button>
            {open && (
                <div className="pcyc-employee-picker-menu">
                    <div className="pcyc-employee-picker-menu-head">
                        <span>Choisir les collaborateurs</span>
                        <button type="button" onClick={() => setOpen(false)} aria-label="Fermer"><X size={15} /></button>
                    </div>
                    <div className="pcyc-employee-picker-search"><Search size={14} /><input autoFocus value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Rechercher..." /></div>
                    <div className="pcyc-employee-picker-actions">
                        <button type="button" onClick={() => onChange(users.map((user) => String(user.id)))}>Tout sélectionner</button>
                        <button type="button" onClick={() => onChange([])}>Tous les collaborateurs</button>
                    </div>
                    <div className="pcyc-employee-picker-options">
                        {filteredUsers.length === 0 ? <p>Aucun collaborateur trouvé.</p> : filteredUsers.map((user) => {
                            const checked = selectedIds.has(String(user.id));
                            return <button key={user.id} type="button" className={`pcyc-employee-picker-option ${checked ? "is-selected" : ""}`} onClick={() => toggleUser(user.id)}>
                                <span className="pcyc-employee-picker-check">{checked && <Check size={13} />}</span>
                                <span>{userName(user)}</span>
                                <small>{user.employeeCode || "—"}</small>
                            </button>;
                        })}
                    </div>
                </div>
            )}
        </div>
    );
}
